import { component } from "picoapp";
import { getSelectedVariant } from "../lib/utils";

export default component((node, ctx) => {
  const bundles = ["pan", "bowls", "plates", "glasses", "trio", "perfect-pot"];
  let checkedValue = null;

  for (let j = 0; j < bundles.length; j++) {
    const inputElements = document.getElementsByClassName(bundles[j]);
    if (inputElements.length > 0) {
      for (let i = 0; inputElements[i]; ++i) {
        if (inputElements[i].checked) {
          checkedValue = inputElements[i].value;
          break;
        }
      }

      document.getElementById(`js-${bundles[j]}`).innerHTML = checkedValue;
    }
  }

  const checkboxes = node.querySelectorAll(".checkbox");

  // fire initial selected variant
  node.querySelectorAll(".checkbox:checked").forEach((el) => {
    const variantId = parseInt(el.dataset.vid);
    const handle = el.dataset.handle;
    const name = el.getAttribute("name");
    getSelectedVariant(handle, variantId);
    node.querySelector(`#js-${name}-description`).innerHTML =
      el.dataset.description;
    document.getElementById(`js-${name}-shippingnote`).innerHTML =
      el.dataset.shippingnote;
  });

  /* eslint-disable no-loop-func */
  for (let i = 0; i < checkboxes.length; i++) {
    checkboxes[i].addEventListener("change", (event) => {
      const name = event.target.getAttribute("name");
      const handle = event.target.dataset.handle;
      getSelectedVariant(handle, parseInt(event.target.dataset.vid));

      node.querySelector(`#js-${name}-description`).innerHTML =
        event.target.dataset.description;
      document.getElementById(`js-${name}`).innerHTML = event.target.value;
      document.getElementById(`js-${name}-shippingnote`).innerHTML =
        event.target.dataset.shippingnote;
    });
  }
});
